module.exports = {
	"data": {
		"markdownRemark": {
			"html": "<p>In this section, you’ll learn how you can send mutations with Apollo. It’s not that different from creati queries and follows similar steps that were mentioned before with queries:</p>\n<ol>\n<li>write the mutation as a ts constant using the <code>gql</code> parser function</li>\n<li>use <code>Apollo</code> service to call the mutation through the <code>mutate</code> method</li>\n</ol>\n<h3>Preparing the Angular components</h3>\n<p>Like before, let’s start by writing the Angular component where users will be able to add new links.</p>\n<Instruction>\nIn the root directory, go ahead and run `ng generate component create-link` and this create `create-link.component.ts` , `create-link.component.spec.ts`, `create-link.component.html`, `create-link.component.css` in `src/app/create-link` folder and add the following code in `create-link.component.ts`:\n<div class=\"gatsby-highlight\">\n      <pre class=\"language-typescript\"  path=\".../hackernews-angular-apollo/src/app/create-link/create-link.component.ts\"  nocopy=\"false\"><code><span class=\"token keyword\">import</span> <span class=\"token punctuation\">{</span>Component<span class=\"token punctuation\">,</span> OnInit<span class=\"token punctuation\">}</span> <span class=\"token keyword\">from</span> <span class=\"token string\">'@angular/core'</span><span class=\"token punctuation\">;</span>\n\n@<span class=\"token function\">Component</span><span class=\"token punctuation\">(</span><span class=\"token punctuation\">{</span>\n  selector<span class=\"token punctuation\">:</span> <span class=\"token string\">'hn-create-link'</span><span class=\"token punctuation\">,</span>\n  templateUrl<span class=\"token punctuation\">:</span> <span class=\"token string\">'./create-link.component.html'</span><span class=\"token punctuation\">,</span>\n  styleUrls<span class=\"token punctuation\">:</span> <span class=\"token punctuation\">[</span><span class=\"token string\">'./create-link.component.css'</span><span class=\"token punctuation\">]</span>\n<span class=\"token punctuation\">}</span><span class=\"token punctuation\">)</span>\n<span class=\"token keyword\">export</span> <span class=\"token keyword\">class</span> <span class=\"token class-name\">CreateLinkComponent</span> <span class=\"token keyword\">implements</span> <span class=\"token class-name\">OnInit</span> <span class=\"token punctuation\">{</span>\n  description<span class=\"token punctuation\">:</span> <span class=\"token keyword\">string</span> <span class=\"token operator\">=</span> <span class=\"token string\">''</span><span class=\"token punctuation\">;</span>\n  url<span class=\"token punctuation\">:</span> <span class=\"token keyword\">string</span> <span class=\"token operator\">=</span> <span class=\"token string\">''</span><span class=\"token punctuation\">;</span>\n\n  <span class=\"token keyword\">constructor</span><span class=\"token punctuation\">(</span><span class=\"token keyword\">public</span> apollo<span class=\"token punctuation\">:</span> Apollo<span class=\"token punctuation\">)</span> <span class=\"token punctuation\">{</span>\n  <span class=\"token punctuation\">}</span>\n\n  <span class=\"token function\">ngOnInit</span><span class=\"token punctuation\">(</span><span class=\"token punctuation\">)</span> <span class=\"token punctuation\">{</span>\n  <span class=\"token punctuation\">}</span>\n\n  <span class=\"token function\">createLink</span><span class=\"token punctuation\">(</span><span class=\"token punctuation\">)</span> <span class=\"token punctuation\">{</span>\n    <span class=\"token comment\" spellcheck=\"true\">// ... you'll implement this in a bit</span>\n  <span class=\"token punctuation\">}</span>\n<span class=\"token punctuation\">}</span>\n</code></pre>\n      </div>\n</Instruction>\n<Instruction>\nThen, add the following code in `create-link.component.html`:\n<div class=\"gatsby-highlight\">\n      <pre class=\"language-html\"  path=\".../hackernews-angular-apollo/src/app/create-link/create-link.component.html\"  nocopy=\"false\"><code><span class=\"token tag\"><span class=\"token tag\"><span class=\"token punctuation\">&lt;</span>div</span> <span class=\"token attr-name\">class</span><span class=\"token attr-value\"><span class=\"token punctuation\">=</span><span class=\"token punctuation\">'</span>flex flex-column mt3<span class=\"token punctuation\">'</span></span><span class=\"token punctuation\">></span></span>\n  <span class=\"token tag\"><span class=\"token tag\"><span class=\"token punctuation\">&lt;</span>input</span>\n    <span class=\"token attr-name\">class</span><span class=\"token attr-value\"><span class=\"token punctuation\">=</span><span class=\"token punctuation\">'</span>mb2<span class=\"token punctuation\">'</span></span>\n    <span class=\"token attr-name\">[(ngModel)]</span><span class=\"token attr-value\"><span class=\"token punctuation\">=</span><span class=\"token punctuation\">\"</span>description<span class=\"token punctuation\">\"</span></span>\n    <span class=\"token attr-name\">type</span><span class=\"token attr-value\"><span class=\"token punctuation\">=</span><span class=\"token punctuation\">'</span>text<span class=\"token punctuation\">'</span></span>\n    <span class=\"token attr-name\">placeholder</span><span class=\"token attr-value\"><span class=\"token punctuation\">=</span><span class=\"token punctuation\">'</span>A description for the link<span class=\"token punctuation\">'</span></span>\n  <span class=\"token punctuation\">/></span></span>\n  <span class=\"token tag\"><span class=\"token tag\"><span class=\"token punctuation\">&lt;</span>input</span>\n    <span class=\"token attr-name\">class</span><span class=\"token attr-value\"><span class=\"token punctuation\">=</span><span class=\"token punctuation\">'</span>mb2<span class=\"token punctuation\">'</span></span>\n    <span class=\"token attr-name\">[(ngModel)]</span><span class=\"token attr-value\"><span class=\"token punctuation\">=</span><span class=\"token punctuation\">\"</span>url<span class=\"token punctuation\">\"</span></span>\n    <span class=\"token attr-name\">type</span><span class=\"token attr-value\"><span class=\"token punctuation\">=</span><span class=\"token punctuation\">'</span>text<span class=\"token punctuation\">'</span></span>\n    <span class=\"token attr-name\">placeholder</span><span class=\"token attr-value\"><span class=\"token punctuation\">=</span><span class=\"token punctuation\">'</span>The URL for the link<span class=\"token punctuation\">'</span></span>\n  <span class=\"token punctuation\">/></span></span>\n<span class=\"token tag\"><span class=\"token tag\"><span class=\"token punctuation\">&lt;/</span>div</span><span class=\"token punctuation\">></span></span>\n<span class=\"token tag\"><span class=\"token tag\"><span class=\"token punctuation\">&lt;</span>button</span>\n  <span class=\"token attr-name\">(click)</span><span class=\"token attr-value\"><span class=\"token punctuation\">=</span><span class=\"token punctuation\">\"</span>createLink()<span class=\"token punctuation\">\"</span></span><span class=\"token punctuation\">></span></span>\n  Submit\n<span class=\"token tag\"><span class=\"token tag\"><span class=\"token punctuation\">&lt;/</span>button</span><span class=\"token punctuation\">></span></span>\n</code></pre>\n      </div>\n<p>Note: <code>[(ngModel)]</code> is the Angular syntax to bind the <code>description</code> and <code>URL</code> property to their textbox. Data flows in both directions: from the property to the textbox, and from the textbox back to the property. <code>NgModel</code> isn’t available by default. It belongs to the optional <code>FormsModule</code>. You must import it in <code>src/app/app.module.ts</code> to be able to use.</p>\n</Instruction>\n<p>This is a standard setup for an Angular component with two <code>input</code> fields where users can provide the <code>URL</code> and <code>description</code> of the <code>Link</code> they want to create. The data that’s typed into these fields is bound in the component’s properties (<code>description</code> and <code>URL</code>) and will be used in <code>createLink</code> when the mutation is sent.</p>\n<h3>Writing the Mutation</h3>\n<p>But how can you now actually send the mutation? Let’s follow the two steps from before.</p>\n<p>First, you need to define the mutation in your <code>graphql</code> file and parse your query with <code>gql</code>. You’ll do that in a similar way as with the query before.</p>\n<Instruction>\n<p>In <code>src/app/graphql.ts</code>, add the following statement to the bottom of the file:</p>\n<div class=\"gatsby-highlight\">\n      <pre class=\"language-typescript\"  path=\".../hackernews-angular-apollo/src/app/graphql.ts\"  nocopy=\"false\"><code><span class=\"token comment\" spellcheck=\"true\">// 1</span>\n<span class=\"token keyword\">export</span> <span class=\"token keyword\">const</span> CREATE_LINK_MUTATION <span class=\"token operator\">=</span> gql<span class=\"token template-string\"><span class=\"token string\">`\n  # 2\n  mutation CreateLinkMutation($description: String!, $url: String!) {\n    createLink(\n      description: $description,\n      url: $url,\n    ) {\n      id\n      createdAt\n      url\n      description\n    }\n  }\n`</span></span><span class=\"token punctuation\">;</span>\n\n<span class=\"token comment\" spellcheck=\"true\">//3</span>\n<span class=\"token keyword\">export</span> <span class=\"token keyword\">interface</span> <span class=\"token class-name\">CreateLinkMutationResponse</span> <span class=\"token punctuation\">{</span>\n  createLink<span class=\"token punctuation\">:</span> Link<span class=\"token punctuation\">;</span>\n  loading<span class=\"token punctuation\">:</span> <span class=\"token keyword\">boolean</span><span class=\"token punctuation\">;</span>\n<span class=\"token punctuation\">}</span>\n</code></pre>\n      </div>\n</Instruction>\n<p>Let’s retake a close look to understand what’s going on:</p>\n<ol>\n<li>You first create the typescript constant called <code>CREATE_LINK_MUTATION</code> that stores the mutation.</li>\n<li>Now you define the actual GraphQL mutation. It takes two arguments, <code>URL</code> and <code>description</code>, that you’ll have to provide when calling the mutation.</li>\n<li>You also declare the response interface of <code>CreateLinkMutationResponse</code></li>\n</ol>\n<Instruction>\n<p>Before moving on, you need to import the mutation from the <code>graphql</code> file and the Apollo dependencies. Add the following to the top of <code>src/app/create-link/create-link.component.ts</code>:</p>\n<div class=\"gatsby-highlight\">\n      <pre class=\"language-typescript\"  path=\".../hackernews-angular-apollo/src/app/create-link/create-link.component.ts\"  nocopy=\"false\"><code><span class=\"token keyword\">import</span> <span class=\"token punctuation\">{</span>Apollo<span class=\"token punctuation\">}</span> <span class=\"token keyword\">from</span> <span class=\"token string\">'apollo-angular'</span><span class=\"token punctuation\">;</span>\n<span class=\"token keyword\">import</span> <span class=\"token punctuation\">{</span>CREATE_LINK_MUTATION<span class=\"token punctuation\">,</span> CreateLinkMutationResponse<span class=\"token punctuation\">}</span> <span class=\"token keyword\">from</span> <span class=\"token string\">'../graphql'</span><span class=\"token punctuation\">;</span>\n</code></pre>\n      </div>\n</Instruction>\n<p>Let’s see the mutation in action!</p>\n<Instruction>\n<p>Still in <code>CreateLinkComponent.ts</code>, implement the <code>createLink</code> mutation as follows:</p>\n<div class=\"gatsby-highlight\">\n      <pre class=\"language-typescript\"  path=\".../hackernews-angular-apollo/src/app/create-link/create-link.component.ts\"  nocopy=\"false\"><code><span class=\"token function\">createLink</span><span class=\"token punctuation\">(</span><span class=\"token punctuation\">)</span> <span class=\"token punctuation\">{</span>\n    <span class=\"token keyword\">this</span><span class=\"token punctuation\">.</span>apollo<span class=\"token punctuation\">.</span>mutate<span class=\"token operator\">&lt;</span>CreateLinkMutationResponse<span class=\"token operator\">></span><span class=\"token punctuation\">(</span><span class=\"token punctuation\">{</span>\n      mutation<span class=\"token punctuation\">:</span> CREATE_LINK_MUTATION<span class=\"token punctuation\">,</span>\n      variables<span class=\"token punctuation\">:</span> <span class=\"token punctuation\">{</span>\n        description<span class=\"token punctuation\">:</span> <span class=\"token keyword\">this</span><span class=\"token punctuation\">.</span>description<span class=\"token punctuation\">,</span>\n        url<span class=\"token punctuation\">:</span> <span class=\"token keyword\">this</span><span class=\"token punctuation\">.</span>url\n      <span class=\"token punctuation\">}</span>\n    <span class=\"token punctuation\">}</span><span class=\"token punctuation\">)</span><span class=\"token punctuation\">.</span><span class=\"token function\">subscribe</span><span class=\"token punctuation\">(</span><span class=\"token punctuation\">(</span>response<span class=\"token punctuation\">)</span> <span class=\"token operator\">=</span><span class=\"token operator\">></span> <span class=\"token punctuation\">{</span>\n\n    <span class=\"token punctuation\">}</span><span class=\"token punctuation\">)</span><span class=\"token punctuation\">;</span>\n<span class=\"token punctuation\">}</span>\n</code></pre>\n      </div>\n</Instruction>\n<p>As promised, all you need to do is call <code>this.apollo.mutate</code> and pass the mutation and the variables that represent the user input.</p>\n<Instruction>\n<p>Go ahead and see if the mutation works. To be able to test the code, open <code>src/app/app.component.html</code> and change the template to looks as follows:</p>\n<div class=\"gatsby-highlight\">\n      <pre class=\"language-html\"  path=\".../hackernews-angular-apollo/src/app/app.component.html\"  nocopy=\"false\"><code><span class=\"token tag\"><span class=\"token tag\"><span class=\"token punctuation\">&lt;</span>hn-link-list</span><span class=\"token punctuation\">></span></span><span class=\"token tag\"><span class=\"token tag\"><span class=\"token punctuation\">&lt;/</span>hn-link-list</span><span class=\"token punctuation\">></span></span>\n<span class=\"token tag\"><span class=\"token tag\"><span class=\"token punctuation\">&lt;</span>hn-create-link</span><span class=\"token punctuation\">></span></span><span class=\"token tag\"><span class=\"token tag\"><span class=\"token punctuation\">&lt;/</span>hn-create-link</span><span class=\"token punctuation\">></span></span>\n</code></pre>\n      </div>\n</Instruction>\n<Instruction>\n<p>Next, check that the <code>CreateLinkComponent</code> components in <code>app.module.ts</code> is declared, the current contents should look like:</p>\n<div class=\"gatsby-highlight\">\n      <pre class=\"language-typescript\"  path=\".../hackernews-angular-apollo/src/app/app.module.ts\"  nocopy=\"false\"><code><span class=\"token keyword\">import</span> <span class=\"token punctuation\">{</span>BrowserModule<span class=\"token punctuation\">}</span> <span class=\"token keyword\">from</span> <span class=\"token string\">'@angular/platform-browser'</span><span class=\"token punctuation\">;</span>\n<span class=\"token keyword\">import</span> <span class=\"token punctuation\">{</span>NgModule<span class=\"token punctuation\">}</span> <span class=\"token keyword\">from</span> <span class=\"token string\">'@angular/core'</span><span class=\"token punctuation\">;</span>\n\n<span class=\"token keyword\">import</span> <span class=\"token punctuation\">{</span>AppComponent<span class=\"token punctuation\">}</span> <span class=\"token keyword\">from</span> <span class=\"token string\">'./app.component'</span><span class=\"token punctuation\">;</span>\n\n<span class=\"token keyword\">import</span> <span class=\"token punctuation\">{</span>GraphQLModule<span class=\"token punctuation\">}</span> <span class=\"token keyword\">from</span> <span class=\"token string\">'./apollo.config'</span><span class=\"token punctuation\">;</span>\n<span class=\"token keyword\">import</span> <span class=\"token punctuation\">{</span>LinkListComponent<span class=\"token punctuation\">}</span> <span class=\"token keyword\">from</span> <span class=\"token string\">'./link-list/link-list.component'</span><span class=\"token punctuation\">;</span>\n<span class=\"token keyword\">import</span> <span class=\"token punctuation\">{</span>LinkItemComponent<span class=\"token punctuation\">}</span> <span class=\"token keyword\">from</span> <span class=\"token string\">'./link-item/link-item.component'</span><span class=\"token punctuation\">;</span>\n<span class=\"token keyword\">import</span> <span class=\"token punctuation\">{</span>CreateLinkComponent<span class=\"token punctuation\">}</span> <span class=\"token keyword\">from</span> <span class=\"token string\">'./create-link/create-link.component'</span><span class=\"token punctuation\">;</span>\n<span class=\"token keyword\">import</span> <span class=\"token punctuation\">{</span>FormsModule<span class=\"token punctuation\">}</span> <span class=\"token keyword\">from</span> <span class=\"token string\">'@angular/forms'</span><span class=\"token punctuation\">;</span>\n\n@<span class=\"token function\">NgModule</span><span class=\"token punctuation\">(</span><span class=\"token punctuation\">{</span>\n  declarations<span class=\"token punctuation\">:</span> <span class=\"token punctuation\">[</span>\n    AppComponent<span class=\"token punctuation\">,</span>\n    LinkListComponent<span class=\"token punctuation\">,</span>\n    LinkItemComponent<span class=\"token punctuation\">,</span>\n    CreateLinkComponent<span class=\"token punctuation\">,</span>\n  <span class=\"token punctuation\">]</span><span class=\"token punctuation\">,</span>\n  imports<span class=\"token punctuation\">:</span> <span class=\"token punctuation\">[</span>\n    BrowserModule<span class=\"token punctuation\">,</span>\n    FormsModule<span class=\"token punctuation\">,</span>\n    GraphQLModule\n  <span class=\"token punctuation\">]</span><span class=\"token punctuation\">,</span>\n  providers<span class=\"token punctuation\">:</span> <span class=\"token punctuation\">[</span><span class=\"token punctuation\">]</span><span class=\"token punctuation\">,</span>\n  bootstrap<span class=\"token punctuation\">:</span> <span class=\"token punctuation\">[</span>AppComponent<span class=\"token punctuation\">]</span>\n<span class=\"token punctuation\">}</span><span class=\"token punctuation\">)</span>\n<span class=\"token keyword\">export</span> <span class=\"token keyword\">class</span> <span class=\"token class-name\">AppModule</span> <span class=\"token punctuation\">{</span>\n<span class=\"token punctuation\">}</span>\n</code></pre>\n      </div>\n</Instruction>\n<p>You should now see the following screen:</p>\n<p><img src=\"https://i.imgur.com/mPiqOCd.png\" alt=\"The CreateLinkComponent\"></p>\n<p>Two input fields and a <em>submit</em>-button - not very pretty but functional.</p>\n<p>Enter some data into the fields, e.g.:</p>\n<ul>\n<li><strong>Description</strong>: <code>The best learning resource for GraphQL</code></li>\n<li><strong>URL</strong>: <code>www.howtographql.com</code></li>\n</ul>\n<p>Then click the <em>submit</em>-button. You won’t get any visual feedback in the UI, but let’s see if the query worked by checking the current list of links in a Playground.</p>\n<p>Type <code>graphcool-framework playground</code> into a Terminal and send the following query:</p>\n<div class=\"gatsby-highlight\">\n      <pre class=\"language-graphql\"   nocopy=\"false\"><code><span class=\"token punctuation\">{</span>\n  allLinks <span class=\"token punctuation\">{</span>\n    description\n    url\n  <span class=\"token punctuation\">}</span>\n<span class=\"token punctuation\">}</span>\n</code></pre>\n      </div>\n<p>You’ll see the following server response:</p>\n<div class=\"gatsby-highlight\">\n      <pre class=\"language-typescript\"   nocopy=\"false\"><code><span class=\"token punctuation\">{</span>\n  <span class=\"token string\">\"data\"</span><span class=\"token punctuation\">:</span> <span class=\"token punctuation\">{</span>\n    <span class=\"token string\">\"allLinks\"</span><span class=\"token punctuation\">:</span> <span class=\"token punctuation\">[</span>\n      <span class=\"token punctuation\">{</span>\n        <span class=\"token string\">\"description\"</span><span class=\"token punctuation\">:</span> <span class=\"token string\">\"The best learning resource for GraphQL\"</span><span class=\"token punctuation\">,</span>\n        <span class=\"token string\">\"url\"</span><span class=\"token punctuation\">:</span> <span class=\"token string\">\"www.howtographql.com\"</span>\n      <span class=\"token punctuation\">}</span><span class=\"token punctuation\">,</span>\n      <span class=\"token comment\" spellcheck=\"true\">// ...</span>\n    <span class=\"token punctuation\">]</span>\n  <span class=\"token punctuation\">}</span>\n<span class=\"token punctuation\">}</span>\n</code></pre>\n      </div>\n<p>Awesome! The mutation works, great job! 💪</p>",
			"fields": {
				"slug": "/angular-apollo/3-mutations-creating-links/"
			},
			"excerpt": "In this section, you’ll learn how you can send mutations with Apollo. It’s not that different from creati queries and follows similar steps...",
			"frontmatter": {
				"title": "Mutations: Creating Links",
				"videoId": null,
				"videoAuthor": null,
				"parent": "/opt/build/repo/content/frontend/angular-apollo/3-mutations-creating-links.md absPath of file",
				"question": "Which of the following statements is true?",
				"answers": [
					"Only queries can be executed with the Apollo service",
					"'gql' is a higher-order component from the apollo-angular package",
					"GraphQL mutations are used for changes (writes) that are made in the database",
					"GraphQL mutations never take any arguments"
				],
				"correctAnswer": 2,
				"description": "Learn how you can use GraphQL mutations with Apollo Client. Use Apollo's service injected in the component to define and send mutations.",
				"pageTitle": "GraphQL Mutations with React & Apollo Tutorial"
			}
		},
		"mds": {
			"edges": [
				{
					"node": {
						"frontmatter": {
							"title": "It was great having you!",
							"description": null
						},
						"fields": {
							"slug": "/success/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Introduction",
							"description": "Learn how to build a GraphQL server with Elixir & Absinthe and best practices for filters, authentication, pagination and subscriptions. Compatible with Apollo."
						},
						"fields": {
							"slug": "/graphql-elixir/0-introduction/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Get started with your favorite technology",
							"description": null
						},
						"fields": {
							"slug": "/choose/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Getting Started",
							"description": "Learn how to setup a GraphQL server with Elixir & Absinthe as well as best practices for defining the GraphQL schema."
						},
						"fields": {
							"slug": "/graphql-elixir/1-getting-started/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Queries",
							"description": "Learn how to define the GraphQL schema with Absinthe, implement query resolvers in Elixir and test your queries in a GraphiQL Playground."
						},
						"fields": {
							"slug": "/graphql-elixir/2-queries/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Summary",
							"description": "You learned how to build a GraphQL server with Elixir & Absinthe and best practices for filters, authentication, pagination and subscriptions."
						},
						"fields": {
							"slug": "/graphql-elixir/4-summary/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Introduction",
							"description": "Learn how to build a GraphQL server with gqlgen."
						},
						"fields": {
							"slug": "/graphql-go/0-introduction/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Mutations",
							"description": "Learn best practices for implementing GraphQL mutations with Absinthe & Elixir. You can test your implementation in a GraphiQL Playground."
						},
						"fields": {
							"slug": "/graphql-elixir/3-mutations/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Queries",
							"description": "what are queries and implementing a query in gqlgen"
						},
						"fields": {
							"slug": "/graphql-go/2-queries/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Getting Started",
							"description": "Creating an app with gqlgen"
						},
						"fields": {
							"slug": "/graphql-go/1-getting-started/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Mutations",
							"description": "what are mutations and implementing a mutation in gqlgen"
						},
						"fields": {
							"slug": "/graphql-go/3-mutations/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Create and Retrieve Links",
							"description": "Enable Users to create Links and see them"
						},
						"fields": {
							"slug": "/graphql-go/5-create-and-retrieve-links/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Auth Endpoints",
							"description": "Enable Users to register, login and refresh their token"
						},
						"fields": {
							"slug": "/graphql-go/7-auth-endpoints/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Introduction",
							"description": "Learn how to build a GraphQL server with graphql-java and best practices for filters, authentication, pagination and subscriptions. Compatible with Apollo."
						},
						"fields": {
							"slug": "/graphql-java/0-introduction/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Summary",
							"description": "Summary of building a GraphQL server with GO backend"
						},
						"fields": {
							"slug": "/graphql-go/9-summary/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Pagination",
							"description": "Learn best practices for implementing limit-offset pagination in a GraphQL API using query arguments with a Node.js & Express GraphQL server."
						},
						"fields": {
							"slug": "/graphql-java/10-pagination/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Logged in User",
							"description": "Get logged-in user in gqlgen"
						},
						"fields": {
							"slug": "/graphql-go/8-logged-in-user-object/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Authentication",
							"description": "Implement authentication in gqlgen with jwt"
						},
						"fields": {
							"slug": "/graphql-go/6-authentication/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Summary",
							"description": "You learned how to build a GraphQL server with graphql-java and best practices for filters, authentication, pagination and subscriptions."
						},
						"fields": {
							"slug": "/graphql-java/12-summary/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Queries",
							"description": "Learn how to define the GraphQL schema with graphql-java, implement query resolvers in Java and test your queries in a GraphiQL Playground."
						},
						"fields": {
							"slug": "/graphql-java/2-queries/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Alternative approaches to schema development",
							"description": "Learn about an alternative approach to developing schemas with graphl-java with graphql-spqr"
						},
						"fields": {
							"slug": "/graphql-java/11-alternative-approaches/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Getting Started",
							"description": "Learn how to setup a GraphQL server with graphql-java and best practices for defining the GraphQL schema in this tutorial."
						},
						"fields": {
							"slug": "/graphql-java/1-getting-started/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Database",
							"description": "Setup mysql db with migrations in golang"
						},
						"fields": {
							"slug": "/graphql-go/4-database/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Mutations",
							"description": "Learn best practices for implementing GraphQL mutations with graphql-java & Java. You can test your implementation in a GraphiQL Playground."
						},
						"fields": {
							"slug": "/graphql-java/3-mutations/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Connectors",
							"description": "Learn how to write connectors in Java to load data from MongoDB with graphql-java and a Java GraphQL server."
						},
						"fields": {
							"slug": "/graphql-java/4-connectors/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "More Mutations",
							"description": "Learn best practices for implementing advanced GraphQL mutations with Java and graphql-java. You can test your implementation in a GraphiQL Playground."
						},
						"fields": {
							"slug": "/graphql-java/6-more-mutations/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Authentication",
							"description": "Learn best practices for implementing email-password authentication on a GraphQL Server written in Java."
						},
						"fields": {
							"slug": "/graphql-java/5-authentication/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Introduction",
							"description": "Learn how to build a GraphQL server with apollo-server, Node.js & Prisma and best practices for authentication, filtering, pagination and subscriptions."
						},
						"fields": {
							"slug": "/graphql-js/0-introduction/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Getting Started",
							"description": "Learn how to setup a GraphQL server with Node.js & Express as well as best practices for defining the GraphQL schema."
						},
						"fields": {
							"slug": "/graphql-js/1-getting-started/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Error Handling",
							"description": "Learn best practices for validation of input arguments and implementing error handling in GraphQL with Java, Node.js & Express."
						},
						"fields": {
							"slug": "/graphql-java/7-error-handling/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "A Simple Query",
							"description": "Learn how to define a GraphQL schema, implement query resolvers with Node.js and test your queries in a GraphQL Playground."
						},
						"fields": {
							"slug": "/graphql-js/2-a-simple-query/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "A Simple Mutation",
							"description": "Learn best practices for implementing GraphQL mutations with graphql-js, Node.js & Prisma. Test your implementation in a GraphQL Playground."
						},
						"fields": {
							"slug": "/graphql-js/3-a-simple-mutation/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Subscriptions",
							"description": "Learn how to implement server-side GraphQL subscriptions with Java to add realtime functionality to an app."
						},
						"fields": {
							"slug": "/graphql-java/8-subscriptions/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Adding a Database",
							"description": "Learn how to add a database to your GraphQL server. The database is powered by Prisma and connected to the server via GraphQL bindings."
						},
						"fields": {
							"slug": "/graphql-js/4-adding-a-database/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Connecting The Server and Database with Prisma Client",
							"description": "Learn how to add a database to your GraphQL server. The database is accessed using Prisma Client."
						},
						"fields": {
							"slug": "/graphql-js/5-connecting-server-and-database/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Filtering",
							"description": "Learn best practices for implementing filters in a GraphQL API using query arguments with a Java GraphQL server."
						},
						"fields": {
							"slug": "/graphql-java/9-filtering/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Getting Started",
							"description": "Setting up a Django Graphene Project"
						},
						"fields": {
							"slug": "/graphql-python/1-getting-started/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Authentication",
							"description": "Learn best practices for implementing authentication and authorization with Node.js, Express & Prisma."
						},
						"fields": {
							"slug": "/graphql-js/6-authentication/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Realtime GraphQL Subscriptions",
							"description": "Learn how to implement GraphQL subscriptions with Node.js, Express & Prisma to add realtime functionality to an app."
						},
						"fields": {
							"slug": "/graphql-js/7-subscriptions/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Introduction",
							"description": "Building a Server with GraphQL and Graphene"
						},
						"fields": {
							"slug": "/graphql-python/0-introduction/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Summary",
							"description": "Tutorial Summary"
						},
						"fields": {
							"slug": "/graphql-python/10-summary/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Summary",
							"description": "You learned how to build a GraphQL server with Node.js and best practices for filters, authentication, pagination and subscriptions."
						},
						"fields": {
							"slug": "/graphql-js/9-summary/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Queries",
							"description": "Creating Your First Queries"
						},
						"fields": {
							"slug": "/graphql-python/2-queries/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Mutations",
							"description": "Creating Data With Mutations"
						},
						"fields": {
							"slug": "/graphql-python/3-mutations/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Authentication",
							"description": "Authenticating on GraphQL"
						},
						"fields": {
							"slug": "/graphql-python/4-authentication/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Error Handling",
							"description": "Handling Errors on GraphQL"
						},
						"fields": {
							"slug": "/graphql-python/6-error-handling/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Filtering",
							"description": "Filtering GraphQL Queries"
						},
						"fields": {
							"slug": "/graphql-python/7-filtering/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Pagination",
							"description": "Simple Pagination with Graphene"
						},
						"fields": {
							"slug": "/graphql-python/8-pagination/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Filtering, Pagination & Sorting",
							"description": "Learn how to add filtering and pagination capabilities to a GraphQL API with Node.js, Express & Prisma."
						},
						"fields": {
							"slug": "/graphql-js/8-filtering-pagination-and-sorting/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Links and Voting",
							"description": "Enable Users to create Links and to Vote on them"
						},
						"fields": {
							"slug": "/graphql-python/5-links-and-voting/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Introduction",
							"description": "Learn how to build a GraphQL server with graphql-ruby and best practices for filters, authentication, pagination and subscriptions. Compatible with Apollo."
						},
						"fields": {
							"slug": "/graphql-ruby/0-introduction/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Getting Started",
							"description": "Learn how to setup a GraphQL server with graphql-ruby and best practices for defining the GraphQL schema."
						},
						"fields": {
							"slug": "/graphql-ruby/1-getting-started/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Relay",
							"description": "Using Relay on Graphene"
						},
						"fields": {
							"slug": "/graphql-python/9-relay/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Mutations",
							"description": "Learn best practices for implementing GraphQL mutations with Ruby and graphql-ruby. You can test your implementation in a GraphiQL Playground."
						},
						"fields": {
							"slug": "/graphql-ruby/3-mutations/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Queries",
							"description": "Learn how to define the GraphQL schema with graphql-ruby, implement query resolvers in Ruby and use a GraphiQL Playground to test your queries."
						},
						"fields": {
							"slug": "/graphql-ruby/2-queries/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Connecting Nodes",
							"description": "Learn best practices for implementing advanced GraphQL mutations with Ruby and graphql-ruby. You can test your implementation in a GraphiQL Playground."
						},
						"fields": {
							"slug": "/graphql-ruby/5-connecting-nodes/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Error Handling",
							"description": "Learn best practices for validation of input arguments and implementing error handling in GraphQL with Ruby."
						},
						"fields": {
							"slug": "/graphql-ruby/6-error-handling/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Filtering",
							"description": "Learn best practices for implementing filters in a GraphQL API using query arguments with a Ruby GraphQL server."
						},
						"fields": {
							"slug": "/graphql-ruby/7-filtering/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Introduction",
							"description": "Learn how to build a GraphQL server with Scala & Sangria and the best practices for filters, authentication and pagination."
						},
						"fields": {
							"slug": "/graphql-scala/0-introduction/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Authentication",
							"description": "Learn best practices for implementing email-password authentication on a GraphQL Server written in Ruby."
						},
						"fields": {
							"slug": "/graphql-ruby/4-authentication/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Getting Started",
							"description": "In this chapter will be described how to setup the HTTP server, install all dependencies and setup the database."
						},
						"fields": {
							"slug": "/graphql-scala/1-getting-started/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Handling Arguments",
							"description": "In this chapter you will learn how to use arguments and how to handle them and pass to the business logic."
						},
						"fields": {
							"slug": "/graphql-scala/3-handling-arguments/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "The first query",
							"description": "In this chapter you will learn last steps of preparation, add graphiql console for easy debugging and at the end, run your first query."
						},
						"fields": {
							"slug": "/graphql-scala/2-preparing-first-query/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Deferred Resolvers",
							"description": "In this chapter you will learn how to improve performance with deferred resolvers."
						},
						"fields": {
							"slug": "/graphql-scala/4-deferred-resolvers/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Custom Scalars",
							"description": "In this chapter Link model will get an additional field to store date and time. You will learn how to handle such custom types and use scalars."
						},
						"fields": {
							"slug": "/graphql-scala/5-custom-scalars/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Interfaces",
							"description": "In this chapter we will introduce two additional models. We show the most common parts and extract those as an interface. This time you will work alone."
						},
						"fields": {
							"slug": "/graphql-scala/6-interfaces/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Pagination",
							"description": "Learn best practices for implementing limit-offset pagination in a GraphQL API using query arguments with Ruby GraphQL server."
						},
						"fields": {
							"slug": "/graphql-ruby/8-pagination/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Mutations",
							"description": "In this chapter you will learn how to add data to the database."
						},
						"fields": {
							"slug": "/graphql-scala/8-mutations/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Summary",
							"description": "You learned how to build a GraphQL server with graphql-ruby & Ruby and best practices for filters, authentication, pagination and subscriptions."
						},
						"fields": {
							"slug": "/graphql-ruby/9-summary/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Authentication",
							"description": "Sangria's Middleware allows pre-processing queries. Gather all useful data in the following subqueries."
						},
						"fields": {
							"slug": "/graphql-scala/9-authentication/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Introduction",
							"description": "Learn how to build a GraphQL server with Apollo, TypeScript, Nexus & Prisma and best practices for authentication, filtering and pagination."
						},
						"fields": {
							"slug": "/typescript-apollo/0-introduction/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Relations",
							"description": "In this chapter you will learn how to connect models with relations. You will also learn how to prepare fetchers to use either relations or ids to get entities."
						},
						"fields": {
							"slug": "/graphql-scala/7-relations/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "A Simple Mutation",
							"description": "Learn best practices for implementing GraphQL mutations with Nexus and TypeScript. Test your implementation in Apollo Studio Explorer."
						},
						"fields": {
							"slug": "/typescript-apollo/3-a-simple-mutation/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Summary",
							"description": "You learned how to build a GraphQL server with TypeScript and best practices for filters, authentication and pagination."
						},
						"fields": {
							"slug": "/typescript-apollo/10-summary/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Connecting The Server and Database with Prisma Client",
							"description": "Learn how to add a database to your GraphQL server. The database is accessed using Prisma Client."
						},
						"fields": {
							"slug": "/typescript-apollo/5-connecting-server-and-database/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Getting Started",
							"description": "Learn how to setup a GraphQL server with TypeScript & Apollo as well as best practices for defining the GraphQL schema."
						},
						"fields": {
							"slug": "/typescript-apollo/1-getting-started/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Adding a Database",
							"description": "Learn how to add a database to your GraphQL server. The database is powered by Prisma."
						},
						"fields": {
							"slug": "/typescript-apollo/4-adding-a-database/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Authentication",
							"description": "Learn best practices for implementing authentication and authorization with TypeScript, Apollo Server & Prisma."
						},
						"fields": {
							"slug": "/typescript-apollo/6-authentication/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Deploying to Production",
							"description": "Inside ."
						},
						"fields": {
							"slug": "/typescript-apollo/9-deployment/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Introduction",
							"description": "Learn how to build a GraphQL server with Node.js, Fastify, TypeScript, GraphQL-Helix & Prisma 3 and best practices for authentication, filtering, pagination and subscriptions."
						},
						"fields": {
							"slug": "/typescript-helix/0-introduction/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Project Setup",
							"description": "Learn how to setup a basic NodeJS & TypeScript project"
						},
						"fields": {
							"slug": "/typescript-helix/1-project-setup/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Summary",
							"description": "You learned how to build a GraphQL server with Node.js and best practices for filters, authentication and pagination"
						},
						"fields": {
							"slug": "/typescript-helix/11-summary/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Filtering, Pagination & Sorting",
							"description": "Learn how to add filtering and pagination capabilities to a GraphQL API with Node.js, Fastify & Prisma."
						},
						"fields": {
							"slug": "/typescript-helix/10-filtering-pagination-and-sorting/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Voting and Custom GraphQL Scalars",
							"description": "Learn how to implement a voting feature and use custom scalars for a Hackernews Clone with Apollo Server, Nexus and Prisma."
						},
						"fields": {
							"slug": "/typescript-apollo/7-voting-and-scalars/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Filtering, Pagination & Sorting",
							"description": "Learn how to add filtering and pagination capabilities to a GraphQL API with TypeScript, Apollo Server & Prisma."
						},
						"fields": {
							"slug": "/typescript-apollo/8-filtering-pagination-and-sorting/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Creating a GraphQL Server",
							"description": "Getting Started with a GraphQL server based on Fastify and GraphQL-Helix"
						},
						"fields": {
							"slug": "/typescript-helix/3-graphql-server/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "A Simple Query",
							"description": "Learn how to define a GraphQL schema with Nexus, implement query resolvers and test your queries in Apollo Studio Explorer"
						},
						"fields": {
							"slug": "/typescript-apollo/2-a-simple-query/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Getting Started",
							"description": "Learn how write a GraphQL schema and how to try and run it."
						},
						"fields": {
							"slug": "/typescript-helix/2-getting-started/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "A Simple Query",
							"description": "Learn how to define a GraphQL schema, implement query resolvers with Node.js and test your queries in a GraphiQL."
						},
						"fields": {
							"slug": "/typescript-helix/4-a-simple-query/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "A Simple Mutation",
							"description": "Learn best practices for implementing GraphQL mutations with graphql-js, Node.js & Prisma. Test your implementation in a GraphiQL."
						},
						"fields": {
							"slug": "/typescript-helix/5-a-simple-mutation/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Introduction",
							"description": "Learn how to build a Hackernews clone with GraphQL, Angular & Apollo Client. You'll use angular-cli for the frontend and Graphcool for the backend."
						},
						"fields": {
							"slug": "/angular-apollo/0-introduction/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Connecting The Server and Database with Prisma Client",
							"description": "Learn how to add a database to your GraphQL server. The database is accessed using Prisma Client."
						},
						"fields": {
							"slug": "/typescript-helix/7-connecting-server-and-database/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Getting Started",
							"description": "Start building a Hackernews clone. Create the frontend with angular-cli and the backend with Graphcool."
						},
						"fields": {
							"slug": "/angular-apollo/1-getting-started/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Summary",
							"description": "In this Fullstack GraphQL Tutorial with Angular & Apollo Client you learned how to build a production-ready Hackernews clone using angular-cli & Graphcool."
						},
						"fields": {
							"slug": "/angular-apollo/11-summary/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Adding a Database",
							"description": "Learn how to add a database to your GraphQL server. The database is powered by Prisma and connected to the server via GraphQL bindings."
						},
						"fields": {
							"slug": "/typescript-helix/6-adding-a-database/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Authentication",
							"description": "Learn best practices for implementing authentication and authorization with Node.js, TypeScript, Fastify & Prisma."
						},
						"fields": {
							"slug": "/typescript-helix/8-authentication/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Deploying",
							"description": "Learn how to deploy an application built with Angular and Graphcool through Surge.sh."
						},
						"fields": {
							"slug": "/angular-apollo/10-deploying/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Queries: Loading link-items",
							"description": "Learn how you can use GraphQL queries with Apollo Client to load data from a server and display it in your Angular components."
						},
						"fields": {
							"slug": "/angular-apollo/2-queries-loading-links/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Mutations: Creating Links",
							"description": "Learn how you can use GraphQL mutations with Apollo Client. Use Apollo's service injected in the component to define and send mutations."
						},
						"fields": {
							"slug": "/angular-apollo/3-mutations-creating-links/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "More Mutations and Updating the Store",
							"description": "Learn how to use Apollo's imperative store API to update the cache after a GraphQL mutation. The updates will automatically end up in your Angular components."
						},
						"fields": {
							"slug": "/angular-apollo/6-more-mutations-and-updating-the-store/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Realtime GraphQL Subscriptions",
							"description": "Learn how to implement GraphQL subscriptions with Node.js, Express & Prisma to add realtime functionality to an app."
						},
						"fields": {
							"slug": "/typescript-helix/9-subscriptions/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Authentication",
							"description": "Learn best practices to implement authentication with GraphQL & Apollo Client to provide an email-and-password-based login in an Angular app with Graphcool."
						},
						"fields": {
							"slug": "/angular-apollo/5-authentication/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Introduction",
							"description": "Learn how to build a Hackernews clone with GraphQL, Ember, and Apollo Client. You'll use Ember and ember-apollo-client for the frontend and Graphcool for the backend."
						},
						"fields": {
							"slug": "/ember-apollo/0-introduction/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Filtering: Searching the List of Links",
							"description": "Learn how to use filters with GraphQL and Apollo Client. Graphcool provides a powerful filter and ordering API that you'll explore in this example."
						},
						"fields": {
							"slug": "/angular-apollo/7-filtering-searching-the-list-of-links/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Realtime Updates with GraphQL Subscriptions",
							"description": "Learn how to implement realtime functionality using GraphQL subscriptions with Apollo Client & Angular. The websockets will be handled by subscriptions-transport-ws."
						},
						"fields": {
							"slug": "/angular-apollo/8-subscriptions/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Routing",
							"description": "Learn how to use Angular Router  together with GraphQL and Apollo Client to implement navigation in an Angular app."
						},
						"fields": {
							"slug": "/angular-apollo/4-routing/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Pagination",
							"description": "Learn how to implement limit-offset pagination with GraphQL and Apollo Client in a Angular app. The Graphcool API exposes the required arguments for lists."
						},
						"fields": {
							"slug": "/angular-apollo/9-pagination/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Summary",
							"description": "In this Fullstack GraphQL Tutorial with Ember & Apollo Client you learned how to build a production-ready Hackernews clone using ember-apollo-client & Graphcool."
						},
						"fields": {
							"slug": "/ember-apollo/8-summary/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Queries: Loading Links",
							"description": "Learn how you can use GraphQL queries with Apollo Client to load data from a server and display it in your React components."
						},
						"fields": {
							"slug": "/ember-apollo/2-queries-loading-links/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Getting Started",
							"description": "Start building a Hackernews clone. Create the frontend with ember-cli, ember-apollo-client, and the backend with Graphcool."
						},
						"fields": {
							"slug": "/ember-apollo/1-getting-started/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Navigation",
							"description": "Learn how to use Ember components together with GraphQL and Apollo Client to implement navigation in an Ember app."
						},
						"fields": {
							"slug": "/ember-apollo/4-navigation/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "More Mutations and Updating the Store",
							"description": "Learn how to use Apollo's imperative store API to update the cache after a GraphQL mutation. The updates will automatically end up in your Ember app."
						},
						"fields": {
							"slug": "/ember-apollo/6-more-mutations-and-updating-the-store/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Summary",
							"description": "In this Fullstack GraphQL Tutorial with React and Apollo Client we learned how to build a production-ready Hackernews clone using create-react-app & Prisma."
						},
						"fields": {
							"slug": "/react-apollo/10-summary/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Filtering: Searching the List of Links",
							"description": "Learn how to use filters with GraphQL and Apollo Client. Graphcool provides a powerful filter and ordering API that you'll explore in this example."
						},
						"fields": {
							"slug": "/ember-apollo/7-filtering-searching-the-list-of-links/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Introduction",
							"description": "Learn how to build a Hackernews clone with GraphQL, React and Apollo Client. Use create-react-app for the frontend and Apollo Server with Prisma for the backend."
						},
						"fields": {
							"slug": "/react-apollo/0-introduction/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Queries: Loading Links",
							"description": "Learn how you can use GraphQL queries with Apollo Client to load data from a server and display it in your React components."
						},
						"fields": {
							"slug": "/react-apollo/2-queries-loading-links/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Mutations: Creating Links",
							"description": "Learn how to use GraphQL mutations with Apollo Client. Use Apollo's `<Mutation />` component to define and send mutations."
						},
						"fields": {
							"slug": "/react-apollo/3-mutations-creating-links/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Getting Started",
							"description": "Start building a Hackernews clone. Create the frontend with create-react-app and the backend with Prisma."
						},
						"fields": {
							"slug": "/react-apollo/1-getting-started/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Routing",
							"description": "Learn how to use React Router 5 together with GraphQL and Apollo Client to implement navigation in a React app. Each route will be represented as a `Link`."
						},
						"fields": {
							"slug": "/react-apollo/4-routing/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Introduction",
							"description": "Learn how to build a production-ready Hackernews clone with GraphQL, React & Relay. You'll use create-react-app for the frontend and Graphcool for the backend."
						},
						"fields": {
							"slug": "/react-relay/0-introduction/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Authentication",
							"description": "Learn best practices to implement authentication with GraphQL & Apollo Client to provide an email-and-password-based login in an Ember app with Graphcool."
						},
						"fields": {
							"slug": "/ember-apollo/5-authentication/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Authentication",
							"description": "Learn best practices to implement authentication with GraphQL and Apollo Client to provide an email/password login in a React app with Prisma."
						},
						"fields": {
							"slug": "/react-apollo/5-authentication/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Mutations: Creating Links",
							"description": "Learn how you can use GraphQL mutations with Apollo Client. Use `ember-apollo-client` to send mutations."
						},
						"fields": {
							"slug": "/ember-apollo/3-mutations-creating-links/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Filtering: Searching the List of Links",
							"description": "Learn how to use filters with GraphQL and Apollo Client. Prisma provides a powerful filter and ordering API that you'll explore in this example."
						},
						"fields": {
							"slug": "/react-apollo/7-filtering-searching-the-list-of-links/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Pagination",
							"description": "Learn how to implement limit-offset pagination with GraphQL and Apollo Client in a React app. The Prisma API exposes the required arguments for lists."
						},
						"fields": {
							"slug": "/react-apollo/9-pagination/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "More Mutations and Updating the Store",
							"description": "Learn how to use Apollo's imperative store API to update the cache after a GraphQL mutation. The updates will automatically be reflected in our React components."
						},
						"fields": {
							"slug": "/react-apollo/6-more-mutations-and-updating-the-store/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Getting Started",
							"description": "Start building a Hackernews clone. Create the frontend with create-react-app and the backend with Graphcool."
						},
						"fields": {
							"slug": "/react-relay/1-getting-started/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Queries: Loading Links",
							"description": "Learn how you can use GraphQL Fragments and Relay's QueryRenderer to load data from a server and display it in your React components."
						},
						"fields": {
							"slug": "/react-relay/2-queries-loading-links/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Mutations: Creating Links",
							"description": "Learn how to use Relay Modern's new Mutation API to send mutations to a GraphQL server. With Relay Modern you can also update the cache directly after the mutation."
						},
						"fields": {
							"slug": "/react-relay/3-mutations-creating-links/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Routing",
							"description": null
						},
						"fields": {
							"slug": "/react-relay/4-routing/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Realtime Updates with GraphQL Subscriptions",
							"description": "Learn how to implement realtime functionality using GraphQL subscriptions with Apollo Client & React. The websockets will be handled by subscriptions-transport-ws."
						},
						"fields": {
							"slug": "/react-apollo/8-subscriptions/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Summary",
							"description": "In this Fullstack GraphQL Tutorial with React & Relay Modern you learned how to build a production-ready Hackernews clone using create-react-app & Graphcool."
						},
						"fields": {
							"slug": "/react-relay/9-summary/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "More Mutations and Updating the Store",
							"description": "Learn how to use Relay Modern's imperative API to update the cache after a GraphQL mutation. The updates will automatically end up in your React components."
						},
						"fields": {
							"slug": "/react-relay/6-more-mutations-and-updating-the-store/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Authentication",
							"description": "Learn best practices to implement authentication with GraphQL & Relay to provide an email-and-password-based login in a React app with Graphcool."
						},
						"fields": {
							"slug": "/react-relay/5-authentication/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Introduction",
							"description": "Learn how to build a Hackernews clone with GraphQL, React & urql. Use create-react-app for the frontend and graphql-yoga & Prisma for the backend."
						},
						"fields": {
							"slug": "/react-urql/0-introduction/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Queries: Loading Links",
							"description": "Learn how you can use GraphQL queries with urql to load data from a GraphQL API and display it in your React components."
						},
						"fields": {
							"slug": "/react-urql/2-queries-loading-links/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Pagination",
							"description": "Learn how to implement cursor-based pagination with GraphQL and Relay Modern using `PaginationContainer`. Relay uses the concept of connections to represent lists."
						},
						"fields": {
							"slug": "/react-relay/8-pagination/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Realtime Updates with Subscriptions",
							"description": "Learn how to implement realtime functionality using GraphQL subscriptions with Relay Modern & React. The websockets will be handled by subscriptions-transport-ws."
						},
						"fields": {
							"slug": "/react-relay/7-subscriptions/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Getting Started",
							"description": "Start building a Hackernews clone. Create the frontend with create-react-app and the backend with Prisma."
						},
						"fields": {
							"slug": "/react-urql/1-getting-started/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Mutations: Creating Links",
							"description": "Learn how you can use GraphQL mutations with urql. Use urql's 'useMutation' hook to define and send mutations."
						},
						"fields": {
							"slug": "/react-urql/3-mutations-creating-links/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Authentication",
							"description": "Learn how to implement authentication with GraphQL & urql to provide an email-&-password login in a React app with Prisma."
						},
						"fields": {
							"slug": "/react-urql/5-authentication/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Pagination and Cache Updates",
							"description": "Learn how to implement limit-offset pagination and cache updates with GraphQL and urql in a React app and update."
						},
						"fields": {
							"slug": "/react-urql/7-pagination-and-cache-updates/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "More Mutations and Queries",
							"description": "Learn more about mutations and queries with React & urql.."
						},
						"fields": {
							"slug": "/react-urql/6-more-mutations-and-queries/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Summary",
							"description": "In this Fullstack GraphQL Tutorial with React & urql you learned how to build a production-ready Hackernews clone using create-react-app & Prisma."
						},
						"fields": {
							"slug": "/react-urql/9-summary/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Realtime Updates with GraphQL Subscriptions",
							"description": "Learn how to implement realtime functionality using GraphQL subscriptions with urql & React. The websockets transport will be handled by subscriptions-transport-ws."
						},
						"fields": {
							"slug": "/react-urql/8-subscriptions/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Introduction",
							"description": "Learn how to build a Hackernews clone with GraphQL, VueJS & Apollo Client. You'll use vue-cli for the frontend and Graphcool for the backend."
						},
						"fields": {
							"slug": "/vue-apollo/0-introduction/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Routing",
							"description": "Learn how to use react-router 5 together with GraphQL and urql to implement navigation in a React app. Each route will be represented as a Link."
						},
						"fields": {
							"slug": "/react-urql/4-routing/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Getting Started",
							"description": "Start building a Hackernews clone. Create the frontend with vue-cli and the backend with Graphcool."
						},
						"fields": {
							"slug": "/vue-apollo/1-getting-started/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Summary",
							"description": "In this Fullstack GraphQL Tutorial with VueJS & Apollo Client you learned how to build a production-ready Hackernews clone using vue-cli & Graphcool."
						},
						"fields": {
							"slug": "/vue-apollo/11-summary/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Queries: Loading Links",
							"description": "Learn how you can use GraphQL queries with Apollo Client to load data from a server and display it in your VueJS components."
						},
						"fields": {
							"slug": "/vue-apollo/2-queries-loading-links/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Deploying",
							"description": "Learn how to deploy an application built with VueJS and Graphcool through Surge.sh."
						},
						"fields": {
							"slug": "/vue-apollo/10-deploying/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Routing",
							"description": "Learn how to use vue-router together with GraphQL and Apollo Client to implement navigation in a VueJS app."
						},
						"fields": {
							"slug": "/vue-apollo/4-routing/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Authentication",
							"description": "Learn best practices to implement authentication with GraphQL & Apollo Client to provide an email-and-password-based login in a VueJS app with Graphcool."
						},
						"fields": {
							"slug": "/vue-apollo/5-authentication/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Realtime Updates with GraphQL Subscriptions",
							"description": "Learn how to implement realtime functionality using GraphQL subscriptions with Apollo Client & VueJS. The websockets will be handled by subscriptions-transport-ws."
						},
						"fields": {
							"slug": "/vue-apollo/8-subscriptions/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Filtering: Searching the List of Links",
							"description": "Learn how to use filters with GraphQL and Apollo Client. Graphcool provides a powerful filter and ordering API that you'll explore in this example."
						},
						"fields": {
							"slug": "/vue-apollo/7-filtering-searching-the-list-of-links/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "More Mutations and Updating the Store",
							"description": "Learn how to use Apollo's imperative store API to update the cache after a GraphQL mutation. The updates will automatically end up in your VueJS components."
						},
						"fields": {
							"slug": "/vue-apollo/6-more-mutations-and-updating-the-store/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Pagination",
							"description": "Learn how to implement limit-offset pagination with GraphQL and Apollo Client in a VueJS app. The Graphcool API exposes the required arguments for lists."
						},
						"fields": {
							"slug": "/vue-apollo/9-pagination/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Mutations: Creating Links",
							"description": "Learn how you can use GraphQL mutations with Apollo Client. Use Apollo's `mutate` method to define and send mutations."
						},
						"fields": {
							"slug": "/vue-apollo/3-mutations-creating-links/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Clients",
							"description": "Learn about GraphQL clients, like Relay and Apollo Client, and the features they provide, such as caching, schema validation and query/view colocation."
						},
						"fields": {
							"slug": "/advanced/0-clients/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Server",
							"description": "Learn about the major concepts of GraphQL servers, how it executes GraphQL queries with resolver functions and batches multiple requests."
						},
						"fields": {
							"slug": "/advanced/1-server/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Tooling and Ecosystem",
							"description": "Learn about the GraphQL ecosystem and its awesome tooling like the GraphiQL playgrounds or self-generating docs through introspection."
						},
						"fields": {
							"slug": "/advanced/3-tooling-and-ecosystem/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "More GraphQL Concepts",
							"description": "Learn about advanced concepts of the GraphQL language like fragments, query arguments, aliases, interfaces and more SDL features"
						},
						"fields": {
							"slug": "/advanced/2-more-graphql-concepts/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Common Questions",
							"description": "Answer common GraphQL questions about server-side caching, authentication, authorization, error handling, offline usage and more."
						},
						"fields": {
							"slug": "/advanced/5-common-questions/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "GraphQL is the better REST",
							"description": "Learn why GraphQL is a more efficient and flexible alternative to REST APIs. It has a strong type system and avoids frontend issues like over- and underfetching."
						},
						"fields": {
							"slug": "/basics/1-graphql-is-the-better-rest/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Security",
							"description": "Learn about different security aspects and strategies for GraphQL, such as timeouts, maximum query depth, query complexity and throttling."
						},
						"fields": {
							"slug": "/advanced/4-security/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Big Picture (Architecture)",
							"description": "Learn about different architectural use cases of GraphQL and the major components on the backend and the frontend, like resolver functions and client libraries."
						},
						"fields": {
							"slug": "/basics/3-big-picture/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Core Concepts",
							"description": "Learn about the basic GraphQL language concepts, such as Queries, Mutations, Subscriptions and the GraphQL Schema & SDL."
						},
						"fields": {
							"slug": "/basics/2-core-concepts/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Introduction",
							"description": "Learn all about GraphQL and why it is an API technology that's superior to REST. It is not only for React & Javascript developers but can be used for any API."
						},
						"fields": {
							"slug": "/basics/0-introduction/"
						}
					}
				}
			]
		}
	},
	"pathContext": {
		"slug": "/angular-apollo/3-mutations-creating-links/"
	}
};


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/angular-apollo-3-mutations-creating-links.json
// module id = ./node_modules/json-loader/index.js!./.cache/json/angular-apollo-3-mutations-creating-links.json
// module chunks = 160